import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { eugeneConfig } from "./data";

export default function EugenePage() {
  return <OregonCityPageTemplate config={eugeneConfig} />;
}